import moment from 'moment'
import axios from '../../axios'

const state = {
  token: '',
  userId: '',
  projectId: '',
  projectName: '',
  startDateOfProject: '',
  firstName: '',
  userGroup: '',
  isSupervisor: '',
  isAdministrator: false,
  isViewer: false
}

const getters = {
  getAuthenticationToken: (state) => state.token,
  getUserId: (state) => state.userId,
  getProjectId: (state) => state.projectId,
  getStartDateOfProject: (state) => state.startDateOfProject,
  getFirstName: (state) => state.firstName,
  getUserGroup: (state) => state.userGroup,
  getIsSupervisor: (state) => state.isSupervisor,
  getIsAdministrator: (state) => state.isAdministrator,
  getIsViewer: (state) => state.isViewer,
  getProjectName: (state) => state.projectName,
  getCurrentWeek: (state) => {
    return moment().diff(moment(state.startDateOfProject), 'weeks')
  }
}

const actions = {
  async fetchUserInformations({ commit }) {
    // Wir nutzen wieder ausschließlich den originalen, sicheren Endpunkt
    const response = await axios.get('user-project-attributions/')

    if (response.data.length > 0) {
      const user = response.data[0].user
      commit('setUserId', user.id)
      commit('setIsSupervisor', user.groups)
      commit('setIsAdministrator', user.groups)
      commit('setIsViewer', user.groups)
      commit('setFirstName', user.first_name)
      commit('setUserGroup', user.groups)
    }
  },

  async fetchProjectId({ commit, state }) {
    const response = await axios.get('user-project-attributions/')

    if (state.isViewer || state.isAdministrator) {
      commit('setProjectId', null)
    } else if (response.data.length > 0) {
      const projectId = response.data.at(-1).project
      commit('setProjectId', typeof projectId === 'object' ? projectId.id : projectId)
    }
  },

  async fetchStartDateOfProject({ commit }) {
    const response = await axios.get('terms/')
    if (response.data.length > 0) {
      commit('setStartDateOfProject', response.data[0].start_date)
    }
  },

  async fetchProjectName({ commit, state }) {
    if (state.projectId) {
      try {
        const response = await axios.get(`projects/${state.projectId}/`)
        commit('setProjectName', response.data.name)
      } catch (error) {
        commit('setProjectName', '')
      }
    } else {
      commit('setProjectName', '')
    }
  }
}

const mutations = {
  setUserId: (state, userId) => (state.userId = userId),
  setProjectId: (state, projectId) => (state.projectId = projectId),
  setProjectName: (state, projectName) => (state.projectName = projectName),
  setStartDateOfProject: (state, startDateOfProject) => (state.startDateOfProject = startDateOfProject),
  setFirstName: (state, firstName) => (state.firstName = firstName),
  setUserGroup: (state, userGroup) => (state.userGroup = userGroup),

  setIsSupervisor: (state, isSupervisor) => {
    state.isSupervisor = false
    isSupervisor.forEach((group) => {
      if (group.name === 'Supervisors') {
        state.isSupervisor = true
      }
    })
  },

  setIsAdministrator: (state, groups) => {
    state.isAdministrator = groups.some((group) => group.name === 'Administrators')
  },

  setIsViewer: (state, groups) => {
    state.isViewer = groups.some((group) => group.name === 'Viewers')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
